export const WALLET_DRAWER_PT_BR = {
	title: "Sua Carteira Zig",
	totalBalance: "Saldo Total",
	transactions: "Transações",
	withdrawal: "Saque",
	anticipation: "Antecipação",
	ticketPayment: "Pagamento de Boletos",
	transferBetweenPlaces: "Transferência entre Places",
};

export type WalletDrawerTranslations = typeof WALLET_DRAWER_PT_BR;
